import { useState, useEffect } from "react";
import axiosInstance from "../../../utility/axiosInstance";

interface IJobFetch {
  id: string;
  currentTemplate: {
    title: string;
  };
  // Add other job properties as needed
}

interface UseJobsReturn {
  jobs: IJobFetch[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useJobs = (): UseJobsReturn => {
  const [jobs, setJobs] = useState<IJobFetch[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchJobs = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axiosInstance.get<{
        message: string;
        data: IJobFetch[];
      }>("/job");
      setJobs(response.data.data);
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to fetch jobs";
      setError(errorMessage);
      console.error("Error fetching jobs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  return { jobs, loading, error, refetch: fetchJobs };
};
